import { GET_ACCOUNT_OWNED_BROADCASTS } from './getAccountOwnedBroadcasts';
import { GET_BROADCAST_BY_ID } from './getBroadcastById';
import { UPLOAD_BROADCAST_ATTACHMENTS } from './uploadAttachments';
import { UPSERT_BROADCAST } from './upsertBroadcast';
import { UPSERT_BROADCAST_TO_USER } from './upsertBroadcastToUser';
import { REMOVE_BROADCAST_ATTACHMENTS } from './removeAttachments';
import { GET_BROADCASTS_SHARED_WITH_ACCOUNT } from './getBroadcastsSharedWithAccount';
import { GET_PORTAL_NOTIFICATIONS_STATUS } from './getPortalNotificationsStatus';
import { GET_GLOBAL_BROADCASTS } from './getGlobalBroadcasts';

export const broadcastApi = {
  getBroadcastById: GET_BROADCAST_BY_ID,
  getAccountOwnedBroadcasts: GET_ACCOUNT_OWNED_BROADCASTS,
  getGlobalBroadcasts: GET_GLOBAL_BROADCASTS,
  getBroadcastsSharedWithAccount: GET_BROADCASTS_SHARED_WITH_ACCOUNT,
  getPortalNotificationsStatus: GET_PORTAL_NOTIFICATIONS_STATUS, // We'll need to move that method out of broadcast query when we have other types of portal notifications. As of now we have broadcast notifications only

  upsertBroadcast: UPSERT_BROADCAST,
  upsertBroadcastToUser: UPSERT_BROADCAST_TO_USER,
  uploadAttachments: UPLOAD_BROADCAST_ATTACHMENTS,
  removeAttachments: REMOVE_BROADCAST_ATTACHMENTS,
};
